module.exports = __webpack_public_path__ + "static/media/search-gayuru.c25f4472.png";